export default __webpack_public_path__ + "static/media/logo.474a068d.svg";